import React, { memo } from 'react'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { usePDFBackgroundImage } from './PDFBackgroundImage.hooks'

const PDFBackgroundImage = props => {
	const [{ classes, image }, { handleClick }] = usePDFBackgroundImage(props)

	return <Image className={clsx(classes.root, 'cta__image')} metaData={image} isBackground onClick={handleClick} />
}
PDFBackgroundImage.propTypes = {
	image: PropTypes.instanceOf(PageMetaData),
	shading: PropTypes.number,
	onClick: PropTypes.func,
}
export default memo(PDFBackgroundImage)
